import { actionConstants } from '../actions/actionConstants';

const initState = {
  isCompleted: false,
  loading: false,
  isSubmitting: false,
  isFetching: false,
  sites: [],
  getSitesError: '',
  createSiteError: '',
  editSiteError: '',
  deleteSiteError: '',
  areas: [],
  getAreasError: '',
  createAreaError: '',
  editAreaError: '',
  deleteAreaError: '',
  departments: [],
  getDepartmentsError: '',
  department: {},
  getDepartmentError: {},
  createDepartmentError: '',
  editDepartmentError: '',
  deleteDepartmentError: '',
  departmentSettings: [],
  getDepartmentSettingsError: '',
  deptSetting: {},
  getDeptSettingError: {},
  departmentSettingsError: '',
  groups: [],
  getGroupsError: '',
  group: {},
  getGroupError: {},
  createGroupError: '',
  usersByGroup: [],
  editGroupError: '',
  deleteGroupError: '',
  roles: [],
  role: {},
  getRoleError: {},
  scheduledReports: [],
  getScheduledReportsError: '',
  scheduledReport: {},
  getScheduledReportError: {},
  createScheduledReportError: '',
  editScheduledReportError: '',
  deleteScheduledReportError: '',
  users: [],
  getUsersError: '',
  user: {},
  getUserError: {},
  createUserError: '',
  editUserError: '',
  alarmIndicators: [],
  alarmMaps: [],
  configAlarmIndicatorError: '',
  createAlarmIndicatorError: '',
  remoteDevices: [],
  getRemoteDevicesError: '',
  remoteDevice: {},
  getRemoteDeviceError: {},
  createRemoteDeviceError: '',
  editRemoteDeviceError: '',
  deleteRemoteDeviceError: '',
  sensors: [],
  getSensorsError: '',
  sensorTypes: [],
  getSensorTypesError: '',
  sensorType: {},
  getSensorTypeError: {},
  createSensorTypeError: '',
  editSensorTypeError: '',
  deleteSensorTypeError: '',
  validationCP: [],
  getValidationCPError: '',
  isOverrided: false,
  isNormalized: false,
  errors: '',
};

const configureReducer = (state = initState, action) => {
  var _state = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case actionConstants.RESET_COMPLETED_FLAG:
      _state.isCompleted = false;
      return _state;
    case actionConstants.START_QUERY:
      return { ...state, errors: '', loading: true };
    case actionConstants.END_QUERY:
      return { ...state, loading: false };
    case actionConstants.START_SUBMISSION:
      return {
        ...state,
        isSubmitting: true,
        errors: '',
        createAlarmIndicatorError: '',
      };
    case actionConstants.END_SUBMISSION:
      return { ...state, isSubmitting: false };
    case actionConstants.START_FETCHING:
      return { ...state, isFetching: true, errors: '' };
    case actionConstants.END_FETCHING:
      return { ...state, isFetching: false };
    case actionConstants.INIT_STATE:
      return { ...initState };
    case actionConstants.CLEAR_ERROR:
      return { ...state, errors: '', getDepartmentError: '' };
    case actionConstants.GET_SITES_SUCCESS:
      _state.sites = action.data;
      return _state;
    case actionConstants.GET_SITES_FAILURE:
      _state.getSitesError = action.data;
      return _state;
    case actionConstants.CREATE_SITE_SUCCESS:
      return _state;
    case actionConstants.CREATE_SITE_FAILURE:
      _state.createSiteError = action.data;
      return _state;
    case actionConstants.EDIT_SITE_SUCCESS:
      return _state;
    case actionConstants.EDIT_SITE_FAILURE:
      _state.editSiteError = action.data;
      return _state;
    case actionConstants.DELETE_SITE_SUCCESS:
      return _state;
    case actionConstants.DELETE_SITE_FAILURE:
      _state.deleteSiteError = action.data;
      return _state;
    case actionConstants.GET_AREAS_SUCCESS:
      _state.areas = action.data;
      return _state;
    case actionConstants.GET_AREAS_FAILURE:
      _state.getAreasError = action.data;
      return _state;
    case actionConstants.CREATE_AREA_SUCCESS:
      return _state;
    case actionConstants.CREATE_AREA_FAILURE:
      _state.createAreaError = action.data;
      return _state;
    case actionConstants.EDIT_AREA_SUCCESS:
      return _state;
    case actionConstants.EDIT_AREA_FAILURE:
      _state.editAreaError = action.data;
      return _state;
    case actionConstants.DELETE_AREA_SUCCESS:
      return _state;
    case actionConstants.DELETE_AREA_FAILURE:
      _state.deleteAreaError = action.data;
      return _state;
    case actionConstants.GET_DEPARTMENTS_SUCCESS:
      return { ...state, departments: action.data.items, loading: false };
    case actionConstants.GET_DEPARTMENTS_FAILURE:
      return { ...state, errors: action.data, loading: false };
    case actionConstants.GET_DEPARTMENT_SUCCESS:
      return { ...state, department: action.data };
    case actionConstants.GET_DEPARTMENT_FAILURE:
      return { ...state, getDepartmentError: action.data, errors: action.data };
    case actionConstants.CREATE_DEPARTMENT_SUCCESS:
      return { ...state, isSubmitting: false };
    case actionConstants.CREATE_DEPARTMENT_FAILURE:
      return { ...state, errors: action.data, isSubmitting: false };
    case actionConstants.EDIT_DEPARTMENT_SUCCESS:
      return { ...state, isSubmitting: false };
    case actionConstants.EDIT_DEPARTMENT_FAILURE:
      return { ...state, errors: action.data, isSubmitting: false };
    case actionConstants.DELETE_DEPARTMENT_SUCCESS:
      return { ...state };
    case actionConstants.DELETE_DEPARTMENT_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_DEPT_SETTINGS_BY_LOCALE_SUCCESS:
      return { ...state, departmentSettings: action.data };
    case actionConstants.GET_DEPT_SETTINGS_BY_LOCALE_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_DEPT_SETTINGS_BY_PARAM_SUCCESS:
      _state.deptSetting = action.data;
      return _state;
    case actionConstants.GET_DEPT_SETTINGS_BY_PARAM_FAILURE:
      _state.getDeptSettingError = action.data;
      return _state;
    case actionConstants.DEPARTMENT_SETTINGS_SUCCESS:
      return { ...state, isSubmitting: false };
    case actionConstants.DEPARTMENT_SETTINGS_FAILURE:
      return { ...state, errors: action.data, isSubmitting: false };
    case actionConstants.GET_GROUPS_SUCCESS:
      return { ...state, groups: action.data.items, loading: false };
    case actionConstants.GET_GROUPS_FAILURE:
      return { ...state, errors: action.data, loading: false };
    case actionConstants.GET_GROUP_SUCCESS:
      return { ...state, group: action.data };
    case actionConstants.GET_GROUP_FAILURE:
      return { ...state, getGroupError: action.data };
    case actionConstants.CREATE_GROUP_SUCCESS:
      return { ...state };
    case actionConstants.CREATE_GROUP_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_USERS_BY_GROUP_SUCCESS:
      return { ...state, usersByGroup: action.data, loading: false };
    case actionConstants.GET_USERS_BY_GROUP_FAILURE:
      return { ...state, errors: action.data, loading: false };
    case actionConstants.ASSIGN_USERS_SUCCESS:
      return { ...state };
    case actionConstants.ASSIGN_USERS_FAILURE:
      return { ...state, errors: action.data, isSubmitting: false };
    case actionConstants.UNASSIGN_USERS_SUCCESS:
      return { ...state, isSubmitting: false };
    case actionConstants.UNASSIGN_USERS_FAILURE:
      return { ...state, errors: action.data, isSubmitting: false };
    case actionConstants.ASSIGN_ALERTS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.EDIT_GROUP_SUCCESS:
      return { ...state };
    case actionConstants.EDIT_GROUP_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.DELETE_GROUP_SUCCESS:
      return { ...state };
    case actionConstants.DELETE_GROUP_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_ROLES_SUCCESS:
      return { ...state, roles: action.data.items };
    case actionConstants.GET_ROLES_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_ROLE_SUCCESS:
      return { ...state, role: action.data };
    case actionConstants.GET_ROLE_FAILURE:
      return { ...state, getRoleError: action.data };
    case actionConstants.CREATE_ROLE_SUCCESS:
      return { ...state };
    case actionConstants.CREATE_ROLE_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.EDIT_ROLE_SUCCESS:
      return { ...state };
    case actionConstants.EDIT_ROLE_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.DELETE_ROLE_SUCCESS:
      return { ...state };
    case actionConstants.DELETE_ROLE_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_SCHEDULED_REPORTS_SUCCESS:
      return { ...state, scheduledReports: action.data.items };
    case actionConstants.GET_SCHEDULED_REPORTS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_SCHEDULED_REPORT_SUCCESS:
      return { ...state, scheduledReport: action.data };
    case actionConstants.GET_SCHEDULED_REPORT_FAILURE:
      return { ...state, getScheduledReportError: action.data };
    case actionConstants.CREATE_SCHEDULED_REPORT_SUCCESS:
      return { ...state };
    case actionConstants.CREATE_SCHEDULED_REPORT_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.EDIT_SCHEDULED_REPORT_SUCCESS:
      return { ...state };
    case actionConstants.EDIT_SCHEDULED_REPORT_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.DELETE_SCHEDULED_REPORT_SUCCESS:
      return { ...state };
    case actionConstants.DELETE_SCHEDULED_REPORT_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_USERS_CONFIG_SUCCESS:
      return { ...state, users: action.data.items };
    case actionConstants.GET_USER_CONFIG_SUCCESS:
      _state.user = action.data;
      return { ...state, user: action.data };
    case actionConstants.CREATE_USER_CONFIG_SUCCESS:
      return { ...state };
    case actionConstants.CREATE_USER_CONFIG_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.EDIT_USER_CONFIG_SUCCESS:
      return { ...state };
    case actionConstants.EDIT_USER_CONFIG_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_ALARM_INDICATORS_SUCCESS:
      return { ...state, alarmIndicators: action.data.items };
    case actionConstants.GET_ALARM_INDICATORS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_ALARM_INDICATORS_BY_DEPT_SUCCESS:
      return { ...state, alarmIndicators: action.data };
    case actionConstants.GET_ALARM_INDICATORS_BY_DEPT_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_ALARM_INDICATORS_ALARM_MAPS_SUCCESS:
      return { ...state, alarmMaps: action.data };
    case actionConstants.GET_ALARM_INDICATORS_ALARM_MAPS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.CONFIG_ALARM_INDICATOR_SUCCESS:
      return { ...state };
    case actionConstants.CONFIG_ALARM_INDICATOR_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.CREATE_ALARM_INDICATOR_SUCCESS:
      return { ...state };
    case actionConstants.CREATE_ALARM_INDICATOR_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_REMOTE_DEVICES_SUCCESS:
      return { ...state, remoteDevices: action.data.items };
    case actionConstants.GET_REMOTE_DEVICES_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_REMOTE_DEVICES_BY_DEPT_SUCCESS:
      return { ...state, remoteDevices: action.data };
    case actionConstants.GET_REMOTE_DEVICES_BY_DEPT_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_REMOTE_DEVICE_SUCCESS:
      return { ...state, remoteDevice: action.data };
    case actionConstants.GET_REMOTE_DEVICE_FAILURE:
      return { ...state, getRemoteDeviceError: action.data };
    case actionConstants.CREATE_REMOTE_DEVICE_SUCCESS:
      return { ...state };
    case actionConstants.CREATE_REMOTE_DEVICE_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.EDIT_REMOTE_DEVICE_SUCCESS:
      return { ...state };
    case actionConstants.EDIT_REMOTE_DEVICE_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.DELETE_REMOTE_DEVICE_SUCCESS:
      return { ...state };
    case actionConstants.DELETE_REMOTE_DEVICE_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.CLEAR_SENSORS:
      return { ...state, sensors: [] };
    case actionConstants.GET_SENSORS_BY_DEPT_SUCCESS:
      _state.sensors = action.data;
      return _state;
    case actionConstants.GET_SENSORS_BY_DEPT_FAILURE:
      _state.getSensorsError = action.data;
      return _state;
    case actionConstants.GET_SENSORS_MV_BY_GROUP_SUCCESS:
      _state.sensors = action.data;
      return _state;
    case actionConstants.GET_SENSORS_MV_BY_GROUP_FAILURE:
      _state.getSensorsError = action.data;
      return _state;
    case actionConstants.DISABLE_SENSOR_SUCCESS:
      return { ...state, isCompleted: true };
    case actionConstants.DISABLE_SENSOR_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.ENABLE_SENSOR_SUCCESS:
      return { ...state, isCompleted: true };
    case actionConstants.ENABLE_SENSOR_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.CLEAR_SENSOR_TYPES:
      return { ...state, sensorTypes: [] };
    case actionConstants.GET_SENSOR_TYPES_SUCCESS:
      return { ...state, sensorTypes: action.data.items };
    case actionConstants.GET_SENSOR_TYPES_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_SENSOR_TYPE_SUCCESS:
      return { ...state, sensorType: action.data };
    case actionConstants.GET_SENSOR_TYPE_FAILURE:
      return { ...state, getSensorTypeError: action.data };
    case actionConstants.GET_SENSOR_TYPES_BY_GROUP_SUCCESS:
      return { ...state, sensorTypes: action.data };
    case actionConstants.GET_SENSOR_TYPES_BY_GROUP_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_SENSOR_TYPES_BY_SCHEDULED_SUCCESS:
      return { ...state, sensorTypes: action.data };
    case actionConstants.GET_SENSOR_TYPES_BY_SCHEDULED_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.CREATE_SENSOR_TYPE_SUCCESS:
      return { ...state };
    case actionConstants.CREATE_SENSOR_TYPE_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.EDIT_SENSOR_TYPE_SUCCESS:
      return { ...state };
    case actionConstants.EDIT_SENSOR_TYPE_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.DELETE_SENSOR_TYPE_SUCCESS:
      return { ...state };
    case actionConstants.DELETE_SENSOR_TYPE_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.GET_VCP_SUCCESS:
      return { ...state, validationCP: action.data };
    case actionConstants.GET_VCP_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.OVERRIDE_VCP_SUCCESS:
      return { ...state, isOverrided: true };
    case actionConstants.OVERRIDE_VCP_FAILURE:
      return { ...state, isOverrided: false };
    case actionConstants.NORMAL_VCP_SUCCESS:
      return { ...state, isNormalized: true };
    case actionConstants.NORMAL_VCP_FAILURE:
      return { ...state, isNormalized: false };
    default:
      return _state;
  }
};
export default configureReducer;
